import * as React from 'react';
export const IcScribble = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21 13h-1.5a8.298 8.298 0 000-3.33 3.35 3.35 0 00-2.2-2.62c-2.25-.75-5.67-.42-9.18 5.44-.73 1.22-1.59 1.83-2.32 1.63A1.17 1.17 0 015 13c0-1 1.17-2.28 2.2-3.45a17.23 17.23 0 001.63-2 3.56 3.56 0 00.71-2.17 2.2 2.2 0 00-1-1.75c-1.38-.93-3.88-.42-5.37 1.82a1 1 0 001.66 1.1C5.73 5.21 7 5 7.44 5.3a.19.19 0 01.1.19 1.62 1.62 0 01-.37 1 21.09 21.09 0 01-1.46 1.74C4.38 9.72 3 11.27 3 13a3.17 3.17 0 002.29 3.05c.61.17 2.75.49 4.57-2.54 1.56-2.6 4-5.5 6.82-4.56.17.05.66.22.89 1.18a6.75 6.75 0 01-.13 2.93 17.12 17.12 0 00-3.36.47C10.71 14.41 10 16.45 10 18a2.77 2.77 0 001.61 2.7c.319.125.658.189 1 .19 1 0 2.33-.45 4.07-2.18A10.4 10.4 0 0018.94 15H21a1 1 0 100-2zm-5.71 4.29c-1.54 1.54-2.56 1.7-2.92 1.56-.36-.14-.37-.69-.37-.85 0-.87.29-1.94 2.59-2.54.702-.175 1.418-.289 2.14-.34a7.81 7.81 0 01-1.44 2.17z'
      fill='currentColor'
    />
  </svg>
);
